<template>
  <modal v-if="isVisible">
    <template v-slot:header>
      <h5 class="modal-title">{{title}}</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
        <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
      </button>
    </template>

    <template v-slot:body>
      <div class="a-checkbox" v-if="canChangeAddressee">
        <label class="a-checkbox__label">
          <input class="a-checkbox__input" type="checkbox" v-model="forAdmin">
          <span class="a-checkbox__icon"></span>
          <span class="a-checkbox__text">{{$t('form.messages.message-to-admin')}}</span>
        </label>
      </div>
      <div class="a-container-form" :class="{ 'a-input-group--error' : $v.to.$error }" v-if="canChangeAddressee">
        <div class="a-label ">{{$t('form.messages.to')}}</div>
        <user-search v-model="to" class="a-input--w-max" :disabled="forAdmin" :allUsers="true"></user-search>
      </div>
      <div class="a-container-form "  :class="{ 'a-input-group--error' : $v.theme.$error || $v.subject.$error }" v-if="canChangeSubject">
        <div class="a-label ">{{$t('form.messages.subject')}}</div>
        <dropdown-new class="select-w-100-percent" v-model="theme" v-if="forAdmin">
          <option v-t="'message-theme.empty'"></option>
          <option :value="enums.MessageTheme.OTHER" :label="'message-theme.other'"></option>
          <option :value="enums.MessageTheme.QUESTION" :labe="'message-theme.question'"></option>
          <option :value="enums.MessageTheme.COMPLAINT" :label="'message-theme.complaint'"></option>
          <option :value="enums.MessageTheme.SUGGESTION" :label="'message-theme.suggestion'"></option>
          <option :value="enums.MessageTheme.REGISTRATION" :label="'message-theme.registration'"></option>
          <option :value="enums.MessageTheme.MAKING_BID" :label="'message-theme.making-bid'"></option>
        </dropdown-new>
        <input type="text" class="a-input a-input--w-max" :placeholder="$t('form.messages.subject')" v-model="subject" v-else>
      </div>

      <div class="a-container-form" v-if="anonymous">
        <p class="a-label">{{$t('labels.email')}}:</p>
        <div class="a-form-field a-width-100-percent">
          <div class="a-input-group">
            <div class="a-input-group__prepend ">@</div>
            <input type="email"
                   class="a-input a-width-100-percent"
                   :placeholder="$t('form.messages.enter-your-email')"
                   v-model.trim="email">
          </div>
          <span class="a-helper-text a-validation-error" v-if="$v.email.$dirty && !$v.email.required">{{$t('labels.mandatory-field')}}</span>
          <span class="a-helper-text a-validation-error" v-else-if="$v.email.$dirty && !$v.email.email">{{$t('validation-error.invalid-format')}}</span>
        </div>
      </div>

      <div class="a-container-form" v-if="anonymous">
        <p class="a-label">{{$t('labels.phone-short')}}:</p>
        <div class="a-form-field a-width-100-percent">
          <div class="a-input-group">
            <div class="a-input-group__prepend ">+</div>
            <input type="text"
                   class="a-input a-width-100-percent"
                   :placeholder="$t('form.messages.enter-your-phone')"
                   v-model.trim="phone">
          </div>
          <span class="a-helper-text a-validation-error" v-if="$v.phone.$dirty && !$v.phone.required">{{$t('labels.mandatory-field')}}</span>
          <span class="a-helper-text a-validation-error" v-else-if="$v.phone.$dirty && !$v.phone.phone">{{$t('validation-error.invalid-format')}}</span>
        </div>
      </div>

      <div class="a-container-form a-container-form--align-start" :class="{ 'a-input-group--error' : $v.body.$error }">
        <div class="a-label ">{{$t('form.messages.body')}}</div>
        <textarea class="a-textarea"
                  rows="6"
                  :placeholder="$t('form.messages.message')"
                  v-model="body"></textarea>
      </div>
      <div class="a-container-form ">
        <div class="a-label ">{{$t('form.messages.file')}}</div>

        <div class="input-file--button-inline a-width-100-percent">
          <file-link :name="file.name"
                     :size="file.size"
                     :removable="true"
                     @remove="onFileRemoveClick"
                     v-if="file">
          </file-link>

          <file-picker :mode="file ? 'button': 'link'"
                       :signing="false"
                       @prepared="onFileSelected">
          </file-picker>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--white-border gui-btn--ep" type="button" @click="close" v-t="'buttons.cancel'"></button>
      <button class="gui-btn gui-btn--red gui-btn--ep" type="button" v-t="'buttons.send'" @click="onSendMessageClick"></button>
    </template>
  </modal>
</template>

<script>
  import _ from 'lodash'
  import { required, requiredIf, email, phone, and} from '@/validators'
  import Modal from '@/widgets/modal'
  import Dropdown from '@/widgets/dropdown'
  import UserSearch from '@/components/common/inputs/UserSearch'

  export default {
    components: {
      Modal,
      UserSearch,
      Dropdown
    },

    data: () => ({
      isVisible: false,
      canChangeAddressee: true,
      canChangeSubject: true,
      title: 'Новое сообщение',

      forAdmin: false,
      anonymous: false,

      subject: undefined,
      body: undefined,
      file: undefined,
      to: undefined,
      theme: undefined,
      email: undefined,
      phone: undefined
    }),

    validations: {
      body: {
        required
      },

      theme: {
        required: requiredIf(function() {
          return this.forAdmin
        })
      },

      subject: {
        required: requiredIf(function() {
          return !this.forAdmin
        })
      },

      to: {
        required: requiredIf(function() {
          return !this.forAdmin
        })
      },

      email: {
        required: requiredIf(function() {
          return this.anonymous
        }),
        email: function(value) {
          return !this.anonymous || email(value)
        }
      },

      phone: {
        required: requiredIf(function() {
          return this.anonymous
        }),
        phone: function(value) {
          return !this.anonymous || phone(value)
        }
      }
    },

    methods: {
      open({ forAdmin, anonymous, theme }) {
        Object.assign(this.$data, this.$options.data.apply(this));

        this.canChangeAddressee = false;
        this.canChangeSubject = false;
        this.forAdmin = forAdmin;
        this.anonymous = !!anonymous;

        this.theme = theme;
        this.title = this.$t(theme.label);

        this.isVisible = true;
      },

      close() {
        this.isVisible = false;
      },

      onFileRemoveClick() {
        this.file = undefined;
      },

      onFileSelected(file) {
        this.file = file;
      },

      async onSendMessageClick() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('postMessage', {
              subject: this.forAdmin ? undefined : this.subject,
              to: this.forAdmin ? undefined : _.get(this.to, 'id'),
              body: this.body,
              theme: this.theme,
              file: this.file,
              email: this.email,
              phone: this.phone
            });
            this.close();
          }
          catch(e) {
            console.error('unable to send message', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .a-input-group--error {
    textarea, .select2-selection {
      border: 1px solid #E9222D;
    }
  }
</style>
